<template>
    <div id="add">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Comments</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">
                <div class="column is-12">
                    <div class="field p5">
                        <span id="filters" class="heading has-text-grey-dark">Apply filter</span>
                        <div class="control has-icons-left has-icons-right">
                            <input id="sentence" class="is-primary" name="sentence" v-model="sentence" v-bind:class="{'input': true, 'is-danger': errors.has('sentence') }"
                                   type="text"
                                   placeholder="Start typing sentence..."></input>
                            <transition name="fade-fast">
                                <span v-show="errors.has('sentence')" class="help is-danger">{{ errors.first('sentence') }}</span>
                            </transition>
                            <span class="icon is-small is-left">
                                        <i class="fa fa-search" v-if='!loading'></i>
                                        <i class="fa fa-spinner fa-spin" v-else></i>
                                        </span>
                        </div>
                    </div>
                </div>
                <div class="column" >
                    <category-list :categories="premadeCategories" @click="togleCategoryFilter"></category-list>
                </div>
            </div>
            <div class="columns is-mutiline">
                <div class="column is-5">
                    <div class="columns is-mutiline box minimal-horizontal-padding">
                        <div class="column is-12 minimal-vertical-margin minimal-vertical-padding">
                            <p class="subtitle is-5 minimal-vertical-margin">Search results:</p>
                            <draggable element="div" class="scroll-y minimal-horizontal-padding" v-model="filteredSentences" v-bind:options="{group:{ name:'sentences',  pull:'clone', put:false }}">
                                <div data-tour-com-step="6" class="card float-left column is-12 is-12-mobile clickable minimal-vertical-margin minimal-vertical-padding" v-scroll-to="'#filters'" v-for='(sentence, index) in filteredSentences' @click='addSentence(sentence)'>
                                    <div class="card-content is-paddingless">
                                        <div class="columns is-desktop is-multiline minimal-vertical-margin minimal-vertical-padding">
                                            <div class="column is-9 is-12-mobile content minimal-vertical-padding">
                                                <p class="has-text-grey-dark is-size-6 multiline-text"> {{sentence.text}} </p>
                                            </div>
                                            <div class="column is-3 is-12-mobile">
                                                <span v-for='category in sentence.premadeCategories'>
                                                    <category-tag :category="category"></category-tag>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
                <div class="column is-7">
                    <div class="columns is-multiline box">
                        <p class="subtitle is-5 minimal-vertical-margin">Selected sentences:</p>
                        <draggable element="div" class="tags conjuncts column is-12 minimal-vertical-padding minimal-vertical-margin" v-model="helperArrays.joiners()"  v-bind:options="{group:{ name:'sentences',  pull:'clone', put:false }}">
                            <span class="tag float-left is-light height-min-content zero-vertical-margin sentence-font-size" v-for="joiner in helperArrays.joiners()" @click='addSentence(joiner)'>{{joiner.text}}</span>
                        </draggable>
                        <div class="column is-12">
                            <div class="message max-height-300">
                                <div class="message-body content minimal-vertical-padding minimal-horizontal-padding comment-sentences">
                                    <a class="delete is-small is-pulled-right" @click="clearChoosedSentences()"></a>
                                    <draggable element="div" v-bind:list="choosedSentences" :options="{group:{ name:'sentences'}}" @change ="generateComment" class="display-inline-block draggable max-height-300 field is-grouped is-grouped-multiline overflow-y-auto" >
                                        <div class="tags float-left has-addons height-min-content minimal-horizontal-padding minimal-vertical-margin" v-for='(sentence, index) in choosedSentences' v-bind:key="index">
                                            <sentence-tag :sentence="sentence" :text="sentence.text" :key="index"></sentence-tag>
                                            <a class="tag is-delete zero-vertical-margin" @click="deleteSentence(index)" ></a>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-multiline box">
                        <p class="subtitle is-5 minimal-vertical-margin">Generated text:</p>
                        <div class="column is-12 ">
                            <pre class="editor-pre"><div @contextmenu.prevent="$refs.ctxMenu.open" contenteditable="true" ref="editor" class="multiline-text editor"></div></pre>
                            <div class="field" style="margin-top:20px">
                                <multiselect placeholder="Choose school" v-model="premadeComment.schools" label="name" track-by="name" name="schools" :options="schools" :multiple="true"></multiselect>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="columns is-multiline">
                <div class="column is-6">
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>
                </div>
                <div class="column is-6">
                    <a class="button is-block is-primary" @click="showSaveModal = true">
                                <span class="icon">
                                      <i class="fa fa-star"></i>
                                </span>
                        <span>Save template</span>
                    </a>
                </div>
            </div>
        </form>
        <div class="modal" v-bind:class="{'is-active': showSaveModal}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Save Comment</p>
                    <button class="delete" aria-label="close" @click="showSaveModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="field">
                        <span class="heading has-text-grey">Give caption to your comment so you can find it more easily:</span>
                        <bulma-input name="caption" v-model="premadeComment.caption" rules="required" placeholder='Comment caption'/>
                    </div>
                    <div class="field">
                        <span class="heading has-text-grey">This comment is meant for students with what score?</span>
                        <star-rating inactive-color="#ababab" :star-size="30" :show-rating="false"  @rating-selected="premadeComment.score = $event" :rating="premadeComment.score"></star-rating>
                    </div>
                </section>
                <footer class="modal-card-foot has-text-right">
                    <loading-button v-bind:loading="saveCommentLoading" color="is-primary" @click="saveComment()">Save</loading-button>
                    <button class="button is-danger is-pulled-right" @click="showSaveModal = false">Cancel</button>
                </footer>
            </div>
        </div>
    </div>


</template>

<script>
import lodash from 'lodash'
import CategoryList from './CategoryList.vue'
import CategoryTag from './CategoryTag.vue'
import SentenceTag from './SentenceTag.vue'
import draggable from 'vuedraggable'


export default {
  name: 'premade-comment',
  components: {CategoryList, draggable, CategoryTag, SentenceTag},
  props:['loadedPremadeComment', 'update'],
  data() {
        return {
            loading: false,
            schools :[],
            premadeComments: {},
            premadeComment: {premadeSentences :[], schools:[], text: '', html: '', caption: '', favorite: 1, score:1},
            sentence :'',
            premadeSentences :[],
            filteredSentences :[],
            choosedSentences :[],
            premadeCategories :[],
            categoryFilters: [],
            showSaveModal: false,
            saveCommentLoading: false,
        }
  },
  created(){
    this.loadSchools();
    this.loadPremadeCategories();
  },
  methods: {

    saveComment(){
        let self = this;
        this.premadeComment.premadeSentences = this.prepareSentencesForServer(this.choosedSentences);
        this.loading = true;
        this.$validator.validateAll().then((result) => {
            if (result) {
                let self = this;
                if(this.update){
                    this.premadeCommentRepo.update(this.premadeComment.id, this.premadeComment).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-comments');
                    }).catch(function(response){
                        self.loading = false;
                        return Promise.reject(response);
                    });
                }else{
                    this.premadeCommentRepo.store(this.premadeComment).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-comments');
                    }).catch(function(response){
                        self.loading = false;
                        return Promise.reject(response);
                    });
                }
            }
        });


    },

      loadPremadeSentences(){
          this.loading = true;
          this.premadeSentenceRepo.all().then(response => {
              this.premadeSentences = response.data.data;
              this.loading = false;
              if(this.premadeCategories.length > 0) {
                  this.premadeSentences = this.updateSentenceColor(this.premadeSentences, this.premadeCategories);
              }
              this.filteredSentences = JSON.parse(JSON.stringify(this.premadeSentences));
          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
      },
      loadPremadeCategories(){
          this.loading = true;
          this.premadeCategoryRepo.all().then(response => {
              this.premadeCategories = response.data.data;
              this.loading = false;
              this.loadPremadeSentences();
          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
      },

      togleCategoryFilter(categoryFilters){

          this.categoryFilters = categoryFilters;
          this.applyFilters();
      },

      applyFilters(direction = 'desc'){
          let toKeep = [];
          this.filteredSentences = JSON.parse(JSON.stringify(this.premadeSentences));
          if(this.categoryFilters.length > 0){
              for(var j=0;j<this.filteredSentences.length;j++){
                  let sentence = this.filteredSentences[j];
                  let hasCategory = false;
                  for(var i=0;i<this.categoryFilters.length;i++){
                      let category = this.categoryFilters[i];
                      for(var k=0;k<sentence.premadeCategories.length;k++){
                          if(category.id == sentence.premadeCategories[k].id){
                              hasCategory = true;
                              break;
                          }
                      }
                  }
                  if(hasCategory === true){

                      toKeep.push(sentence);
                  }
              }

              this.filteredSentences = toKeep;
          }

          if(this.sentence != ''){
              this.filteredSentences = this.filteredSentences.filter(sentence => {
                      return sentence.text.toLowerCase().includes(this.sentence.toLowerCase())
                  })
          }

          this.filteredSentences = _.orderBy(this.filteredSentences, function(e) {

              if(e.premadeCategories != null && e.premadeCategories.length > 0){
                  return e.premadeCategories[0].id;
              }

              return e.id;
          }, [direction]);
      },

      addSentence(sentence){
          this.choosedSentences.push(sentence);
          this.generateComment();
      },

      deleteSentence(index){
          this.choosedSentences.splice(index, 1);
          this.generateComment();
      },
      clearChoosedSentences(){
          this.choosedSentences = [];
          this.generateComment();
      },
      generateComment(){

          this.premadeComment.text = "";
          let self = this;
          let wasJoiner = false;
          _.forEach(this.choosedSentences, function(sentence) {

              if(!sentence.isJoiner){
                  if(self.premadeComment.text != ""){
                      self.premadeComment.text += " ";
                  }
                  let filtered = sentence.text;
                  if(wasJoiner){
                      filtered = filtered.charAt(0).toLowerCase() + filtered.slice(1);
                  }

                  self.premadeComment.text +=filtered;
              }
              else{
                  let comment = self.premadeComment.text;
                  if(comment.substring(comment.length-1) == "." || comment.substring(comment.length-1) == "!"
                      || comment.substring(comment.length-1) == "," || comment.substring(comment.length-1) == "?")
                  {
                      comment = comment.substring(0, comment.length-1);
                  }

                  self.premadeComment.text = comment + sentence.value;
              }

              wasJoiner = sentence.isJoiner;
          });

          this.premadeComment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.premadeComment.text;
      },
    },
  watch: {
      sentence: _.debounce(function(value){
          if(value.length >= 3){

              this.searching = true;
              this.applyFilters();
              this.loading = false;
          }
          else if(value == ''){
              this.applyFilters();
          }
      }, 800),
      loadedPremadeComment: function(value){
          this.premadeComment.text = this.premadeComment.html = value.text;
          this.premadeComment.caption = value.caption;
          this.premadeComment.favorite = value.favorite;
          this.premadeComment.score = value.score;
          this.premadeComment.id = value.id;
          this.premadeComment.schools = value.schools;
          this.premadeComment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.premadeComment.text;
          this.choosedSentences = this.prepareSentencesForClient(value.premadeSentences);
      },

  }

}
</script>

<style lang="css" scoped>


    @keyframes click-wave {
        0% {
            height: 20px;
            width: 20px;
            opacity: 0.35;
            position: relative;
        }
        100% {
            height: 30px;
            width: 30px;
            margin-left: -5px;
            margin-top: -5px;
            opacity: 0;
        }
    }

    .option-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        position: relative;
        top: 4.33333px;
        right: 0;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 20px;
        transition: all 0.15s ease-out 0s;
        background: #cbd1d8;
        border: none;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        margin-right: 0.5rem;
        margin-left: 0.5rem;
        outline: none;
        position: relative;
        z-index: 11;
    }
    .option-input:hover {
        background: #9faab7;
    }
    .option-input:checked {
        background: #00d1b2!important;
    }
    .option-input:checked::before {
        height: 20px;
        width: 20px;
        position: absolute;
        content: '✔';
        display: inline-block;
        font-size: 13.3333px;
        text-align: center;
        line-height: 20px;
    }
    .option-input:checked::after {
        -webkit-animation: click-wave 0.65s;
        -moz-animation: click-wave 0.65s;
        animation: click-wave 0.65s;
        background: #00d1b2!important;
        content: '';
        display: block;
        position: relative;
        z-index: 10;
    }
    .option-input.radio {
        border-radius: 50%;
    }
    .option-input.radio::after {
        border-radius: 50%;
    }
    .option-input span {
        padding-top: 10px;
    }

    .draggable{
        min-height: 70px;
    }

    .card-content{
        padding-top:2px;
        padding-bottom:2px;
    }


    .max-height-300{
        height: 300px;
        max-height: 300px;
    }

    .height-auto{
        height:auto;
    }

    .height-min-content{
        height: min-content;
    }

    .clear-star{
        margin-top: 7px;
        margin-left: 5px;
    }

    .float-left{
        float: left;
    }

    .display-block{
        display: block;
    }

    .sentence-font-size{
        font-size: 0.95rem !important;
    }

    .min-height-100{
        min-height: 100px;
        height: fit-content;
    }

    .editor{
        min-height: 300px;
        overflow: auto;
        font-size: 14px;
        line-height: 1.5;
        background-color: #fff;
        color: #333;
        overflow: hidden;
        text-align: justify;
        font-family: 'Pfdintextpro';
        white-space: pre-line !important;
        border:none;
        width: 100% !important;
        max-width: 100% !important;
        padding: 0px;
    }

    .editor:active, .editor:focus{
        border:none;
        outline:none;
    }
    .editor-pre{
        border: 1px solid #ddd;
        text-align: left;
        border-radius: 5px;
        padding: 10px;
        min-height: 300px;
        font-size: 14px;
        line-height: 1.5;
        background-color:transparent;
    }
    .display-initial{
        display: initial;
    }

    .display-inline-block{
        display: inline-block;
    }

    .conjuncts{
        height: 18px;
    }
    .ctx-menu.ctx-menu-left li{
        padding-left: 10px;
        line-height: 24px;
    }

    .ctx-menu.ctx-menu-left li:hover{
        cursor: pointer;
        color: white;
        background-color: #00d1b2;
    }

    .ctx-menu.ctx-menu-left li span{
        padding-left: 5px;
    }

    .overflow-y-auto{
        overflow-y: auto;
    }

    .comment-sentences{
        background-color: whitesmoke;
        border: none
    }

    .comment-sentences .field.is-grouped.is-grouped-multiline:last-child{
        margin-bottom: 0.25rem
    }

    a.is-danger{
        color: rgb(255, 56, 96);
    }

    .tooltip.is-tooltip-bottom:focus::before, .tooltip.is-tooltip-bottom:hover::before, .tooltip.is-tooltip-bottom.is-tooltip-active::before {
        transform: translate(-50%, 0.5rem);
        min-width: 300px;
        text-align: justify;
    }

    @media screen and (max-width: 768px){
        .tabs ul{
            width: 100%;
            display: block;
        }
        .tabs li{
            width: 100%;
        }

        .tabs li a{
            height: 60px;
        }

    }
    .modal{
        z-index: 999 !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/premade-comments/components/PremadeComment.vue